// Source of truth for SEO blog articles (K'REUSE EXTÉRIEUR).
// Each post drives /conseils/:slug, /conseils index, sitemap and JSON-LD.
export const POSTS = [
  {
    slug: "rats-souris-automne-signes-infestation-prevention",
    seoTitle: "Rats et souris à l'automne : signes et prévention | K'REUSE",
    seoDescription: "Crottes, bruits, rongements : repérer une infestation de rats ou de souris à l'automne en Creuse et les gestes de prévention qui fonctionnent.",
    title: "Rats et souris à l'automne : signes d'infestation et prévention",
    excerpt:
      "Avec le froid, rats et souris cherchent un abri. Les indices qui doivent alerter, les points d'entrée à surveiller et les gestes simples pour les tenir à distance.",
    date: "2026-10-19",
    readMin: 6,
    category: "Anti-nuisibles",
    image: "/img/blog/rats-souris-automne-grange.webp",
    keywords: ["rats souris automne", "signes infestation rongeurs", "prévention rats Creuse", "dératisation Creuse"],
  },
  {
    slug: "taille-elagage-automne-hiver-bon-moment",
    seoTitle: "Taille et élagage en automne-hiver : le bon moment | K'REUSE",
    seoDescription: "Quand tailler et élaguer en automne et en hiver ? Arbres, haies, fruitiers : les bonnes périodes, les erreurs à éviter et les règles à connaître.",
    title: "Taille et élagage en automne-hiver : le bon moment",
    excerpt:
      "Repos végétatif, gel, fruitiers, haies, voisinage : notre guide pour choisir le bon moment de taille et d'élagage en automne et en hiver en Creuse.",
    date: "2026-10-12",
    readMin: 6,
    category: "Jardin",
    image: "/img/blog/elagage-automne-hiver.webp",
    keywords: ["élagage hiver", "taille automne", "quand élaguer", "élagage Creuse"],
  },
  {
    slug: "nid-frelons-asiatiques-vide-hiver-que-faire",
    seoTitle: "Nid de frelons asiatiques vide en hiver : que faire ? | K'REUSE",
    seoDescription: "Un nid de frelons asiatiques vide dans un arbre en hiver est-il dangereux ? Faut-il le retirer ? Ce qu'il faut savoir et quoi surveiller au printemps.",
    title: "Que faire d'un nid de frelons asiatiques vide en hiver ?",
    excerpt:
      "Quand les feuilles tombent, les nids apparaissent. Un nid vide est-il encore dangereux, faut-il le détruire, et que surveiller au printemps ? Nos réponses.",
    date: "2026-10-05",
    readMin: 5,
    category: "Anti-nuisibles",
    image: "/img/blog/nid-frelons-asiatiques-vide-hiver.webp",
    keywords: ["nid frelons asiatiques vide", "nid frelon hiver", "frelon asiatique Creuse", "destruction nid frelons"],
  },
  {
    slug: "chenilles-processionnaires-quand-comment-s-en-debarrasser-creuse",
    seoTitle: "Chenilles processionnaires : quand et comment agir | K'REUSE",
    seoDescription: "Calendrier de lutte contre les chenilles processionnaires du pin et du chêne en Creuse : échenillage, éco-pièges, pièges à phéromones, mésanges.",
    title: "Chenilles processionnaires : quand et comment s'en débarrasser en Creuse",
    excerpt:
      "Chaque méthode a sa saison. Le calendrier de lutte mois par mois contre les chenilles processionnaires du pin et du chêne, pour agir au bon moment.",
    date: "2026-09-28",
    readMin: 6,
    category: "Anti-nuisibles",
    image: "/img/blog/chenilles-processionnaires-nid-pin.webp",
    keywords: ["chenilles processionnaires Creuse", "échenillage", "éco-piège chenilles", "quand traiter chenilles processionnaires"],
  },
  {
    slug: "punaises-de-lit-reconnaitre-traiter-eviter",
    seoTitle: "Punaises de lit : reconnaître, traiter, éviter | K'REUSE",
    seoDescription: "Comment repérer des punaises de lit, les erreurs à éviter et le traitement professionnel efficace en Creuse pour stopper toute récidive.",
    title: "Punaises de lit : reconnaître, traiter et éviter la récidive",
    excerpt:
      "Comment identifier une infestation de punaises de lit, les erreurs à éviter, le traitement professionnel efficace en Creuse et les astuces pour ne pas subir une récidive.",
    date: "2026-03-05",
    readMin: 8,
    category: "Anti-nuisibles",
    image:
      "/img/photos/elagage.webp",
    keywords: [
      "punaises de lit Creuse",
      "traitement punaises Guéret",
      "vapeur sèche punaises",
      "éradication punaises de lit",
    ],
  },
  {
    slug: "difference-guepe-frelon-frelon-asiatique",
    seoTitle: "Guêpe, frelon européen ou asiatique ? | K'REUSE",
    title: "Guêpe, frelon européen ou frelon asiatique : comment les différencier ?",
    excerpt:
      "Taille, couleur, comportement, forme du nid : notre guide comparatif complet pour identifier avec certitude les 3 espèces qui piquent en Creuse.",
    date: "2026-03-02",
    readMin: 6,
    category: "Anti-nuisibles",
    image:
      "/img/photos/nid-frelons.webp",
    keywords: [
      "différence guêpe frelon",
      "vespa velutina crabro",
      "identifier frelon asiatique",
      "pattes jaunes frelon",
    ],
  },
  {
    slug: "prix-intervention-anti-nuisibles-creuse",
    seoTitle: "Prix d'une intervention anti-nuisibles en Creuse | K'REUSE",
    title: "Prix d'une intervention anti-nuisibles en Creuse : le vrai coût",
    excerpt:
      "Grille tarifaire honnête pour la destruction de nids, dératisation, traitement punaises de lit, désinfection en Creuse. Sans devis flou, sans coût caché.",
    date: "2026-02-28",
    readMin: 7,
    category: "Anti-nuisibles",
    image:
      "/img/photos/chenille.webp",
    keywords: [
      "prix nid de frelons",
      "coût dératisation Creuse",
      "tarif punaises de lit",
      "devis anti-nuisibles",
    ],
  },
  {
    slug: "reconnaitre-nid-frelons-asiatiques-creuse",
    seoTitle: "Reconnaître un nid de frelons asiatiques | K'REUSE",
    title: "Comment reconnaître un nid de frelons asiatiques : le guide 2026",
    excerpt:
      "Nid primaire, nid secondaire, hauteur, forme, activité : voici comment identifier avec certitude un nid de frelons asiatiques dans votre jardin en Creuse.",
    date: "2026-02-24",
    readMin: 6,
    category: "Anti-nuisibles",
    image:
      "/img/photos/nid-frelons.webp",
    keywords: [
      "reconnaître nid frelons asiatiques",
      "identifier vespa velutina",
      "nid primaire secondaire",
      "frelons asiatiques Creuse",
    ],
  },
  {
    slug: "deratisation-creuse-quand-faire-appel-professionnel",
    seoTitle: "Dératisation en Creuse : quand appeler un pro ? | K'REUSE",
    seoDescription: "Traces de rongeurs, dégâts, risques sanitaires : les signes qui doivent alerter et les solutions durables d'un professionnel en Creuse.",
    title: "Dératisation en Creuse : quand faire appel à un professionnel ?",
    excerpt:
      "Traces de rongeurs, dégâts, risques sanitaires : voici les signes qui doivent vous alerter et les solutions durables proposées par un professionnel en Creuse.",
    date: "2026-02-20",
    readMin: 5,
    category: "Anti-nuisibles",
    image:
      "/img/photos/rat.webp",
    keywords: [
      "dératisation Creuse",
      "rats souris Guéret",
      "professionnel rongeurs 23",
      "entreprise dératisation",
    ],
  },
  {
    slug: "chenilles-processionnaires-danger-traitement",
    seoTitle: "Chenilles processionnaires : danger et traitement | K'REUSE",
    seoDescription: "Dangers pour l'homme et les animaux, période à risque, traitements (échenillage, éco-pièges) : tout savoir sur les chenilles processionnaires.",
    title: "Chenilles processionnaires : danger et traitement en Creuse",
    excerpt:
      "Dangers pour l'homme et les animaux, période à risque, moyens de traitement (échenillage, éco-pièges) : ce qu'il faut savoir sur les chenilles processionnaires.",
    date: "2026-02-18",
    readMin: 5,
    category: "Anti-nuisibles",
    image:
      "/img/photos/credit-impot.webp",
    keywords: [
      "chenilles processionnaires Creuse",
      "traitement chenilles pin",
      "échenillage 23",
      "éco-piège chenilles",
    ],
  },
  {
    slug: "frelons-asiatiques-creuse-que-faire",
    seoTitle: "Frelons asiatiques en Creuse : que faire ? | K'REUSE",
    title: "Frelons asiatiques en Creuse : que faire en cas de nid près de chez vous ?",
    excerpt:
      "Reconnaître un nid de frelons asiatiques, comprendre les dangers et savoir qui appeler en Creuse (23) pour une destruction sécurisée et rapide.",
    date: "2026-02-12",
    readMin: 6,
    category: "Anti-nuisibles",
    image:
      "/img/photos/nid-frelons.webp",
    keywords: [
      "frelon asiatique Creuse",
      "nid de frelons Guéret",
      "destruction frelons 23",
      "vespa velutina",
    ],
  },
  {
    slug: "credit-impot-50-entretien-jardin",
    seoTitle: "Crédit d'impôt 50% entretien jardin : le guide | K'REUSE",
    title: "Crédit d'impôt 50% sur l'entretien de jardin : comment en bénéficier en 2026 ?",
    excerpt:
      "Tonte, taille, désherbage : 50% des sommes versées à un professionnel agréé services à la personne reviennent dans votre poche. On vous explique tout.",
    date: "2026-02-05",
    readMin: 5,
    category: "Paysagisme",
    image:
      "/img/photos/entretien-jardin.webp",
    keywords: [
      "crédit d'impôt jardinage",
      "services à la personne jardin",
      "avance immédiate URSSAF",
      "entretien jardin Creuse",
    ],
  },
  {
    slug: "calendrier-tonte-taille-saisonniere",
    seoTitle: "Calendrier tonte et taille du jardin en Creuse | K'REUSE",
    title: "Calendrier de tonte et de taille saisonnière : le guide du jardin en Creuse",
    excerpt:
      "Quand tondre, quand tailler, quand laisser tranquille ? Notre calendrier mois par mois adapté au climat de la Creuse pour un jardin toujours impeccable.",
    date: "2026-01-28",
    readMin: 7,
    category: "Conseils jardin",
    image:
      "/img/photos/jardin-paysager.webp",
    keywords: [
      "calendrier tonte gazon",
      "taille haie saison",
      "entretien jardin mois par mois",
      "paysagiste Creuse",
    ],
  },
];

export function getPostBySlug(slug) {
  return POSTS.find((p) => p.slug === slug);
}
